import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-pers-facts',
  templateUrl: './pers-facts.component.html',
  styleUrls: ['./pers-facts.component.css']
})
export class PersFactsComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_persfacts_grid')
                .setLoadDataFunction({
                    method: 2924,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'persfacts_new',
                    text: 'persfacts_new',
                    func: () => this.stateService?.go('persfactsedit', { pers_facts_id: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('persfacts', {
//        templateUrl: 'views/components/views/persfacts/persfacts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_persfacts_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'persfacts_new',
//                text: 'persfacts_new',
//                func: () => stateService.go('persfactsedit', { pers_facts_id: '0' }),
//                icon: 'fa-plus',
//                cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                translate: true
//            }])
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 2924,
//                    parameters: {}
//                });

//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
